function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M127.6 127.6H0V0h127.6v127.6zM28.4 99.2h70.8V28.4H28.4v70.8zm255.1 28.4H155.9V0h127.6v127.6zm-99.2-28.4h70.8V28.4h-70.8v70.8zm-56.7 184.3H0V155.9h127.6v127.6zm-99.2-28.4h70.8v-70.8H28.4v70.8zm255.1 28.4H155.9V155.9h127.6v127.6zm-99.2-28.4h70.8v-70.8h-70.8v70.8z"
})));